// extracted by mini-css-extract-plugin
export default {"container":"kiosk-relations_container__N6ZxC","queryContainer":"kiosk-relations_queryContainer__pX83c","queryButton":"kiosk-relations_queryButton__ZU2Em"};